import { makeUseAxios } from 'axios-hooks'
import { createAxiosInstance } from './createAxiosInstance'

const vercelServerlessRequest = createAxiosInstance({ baseURL: '' })

export const useVercelServerlessAxios = makeUseAxios({
  axios: vercelServerlessRequest,
  defaultOptions: { manual: true },
})

export default vercelServerlessRequest
